import { cardsData } from '@/mocks/home';

export default function Cards() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-10">
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-3">
              <i className="ri-article-line"></i>
              最新爆料
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              吃瓜热门爆料
            </h2>
            <p className="text-sm text-foreground-500 mt-2">
              最新最热的娱乐黑料与八卦资讯一网打尽
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
            {cardsData.map((card) => (
              <article
                key={card.id}
                className="rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-200 group cursor-pointer"
              >
                <div className="relative overflow-hidden aspect-[3/2]">
                  <img
                    src={card.image}
                    alt={`51吃瓜爆料 - ${card.title}`}
                    title={`51吃瓜网今日吃瓜 - ${card.title}`}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    width="600"
                    height="400"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-2 py-1 rounded-md bg-primary-500 text-background-50 text-[10px] font-bold">
                      {card.category}
                    </span>
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="text-sm md:text-base font-medium text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 mb-2">
                    {card.title}
                  </h3>
                  <p className="text-xs text-foreground-500 line-clamp-2 mb-3">
                    {card.excerpt}
                  </p>
                  <div className="flex items-center justify-between text-[10px] md:text-xs text-foreground-400">
                    <span className="flex items-center gap-1">
                      <i className="ri-time-line"></i>
                      {card.time}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i>
                      {card.views}阅读
                    </span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}